// import consts from "@/consts.js";
import Request from './request';


async function fetch(data) {
    return Request('get', "api/account-logs/index", data);
}

async function fetchLogTypes(data) {
    return Request('get', "api/account-logs/log-types", data);
}

async function fetchBatches(data) {
    return Request('get', "api/batch-logs/index", data);
}

async function fetchJobs(data) {
    return Request('get', "api/task-logs/get-job-logs", data);
}

async function fetchBatchLogs(data) {
    return Request('get', "api/task-logs/get-batch-logs", data);
}

async function fetchSyncErrs(data) {
    return Request('get', "api/task-logs/get-sync-err-logs", data);
}

async function fetchQueueDataLogs(data) {
    return Request('get', "api/queue-datas", data);
}

async function getQueueDataTypes(data) {
    return Request('get', "api/queue-datas/get-types", data);
}

async function queueDataRePush(id) {
    return Request('get', "api/queue-datas/re-push?id=" + id);
}

async function getPricingLogs(data) {
    return Request('get', "api/pricing-logs", data);

}

export default {
    fetch, 
    fetchLogTypes,
    fetchBatches,
    fetchJobs,
    fetchBatchLogs,
    fetchSyncErrs,
    fetchQueueDataLogs,
    getQueueDataTypes,
    queueDataRePush,
    getPricingLogs,
};